import Dummy from './Dummy'

export default Dummy


// WEBPACK FOOTER //
// ./src/components/Dummy/index.js